import Api from '../../library/api';
import { showError } from '../snackbars/snackbars-actions';

export const REQUEST_CONIFRM_PASSWORD = 'REQUEST_CONIFRM_PASSWORD';
export const CONIFRM_PASSWORD_FAILED = 'CONIFRM_PASSWORD_FAILED';
export const CONIFRM_PASSWORD_SUCCESS = 'CONIFRM_PASSWORD_SUCCESS';


export function resetConfirm(password, guid, responseCallback) {
  return dispatch => {


    dispatch({ type: REQUEST_CONIFRM_PASSWORD });

    Api.post('p/reset-confirm', { password, guid }, responseCallback)
      .then(resp => {

        console.log({ resp })
        if (resp.err) {
          dispatch({ type: CONIFRM_PASSWORD_FAILED });
          dispatch(showError(resp.err));
          return
        } else {
          responseCallback(true)
        }

        // "admin": false,
        // "role": "Owner",
        // "business": true,
        // "business_name": "Enjoy Space"

        resp.permissions = {
          admin: resp.admin
        };

        dispatch({
          type: CONIFRM_PASSWORD_SUCCESS,
          payload: resp
        })

      });

  }
}



// WEBPACK FOOTER //
// ./src/components/reset-password/reset-confirm-actions.js